'use client';

import { useEffect } from 'react';
import { Heading, Text, Button } from '@terra/ui-design-system';
import { Box, Flex, VStack } from '@terra/ui-styled-system';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Error boundary caught an error:', error);
  }, [error]);

  return (
    <Flex direction="column" align="center" justify="center" h="full">
      <VStack gap={8} textAlign="center" maxWidth="1200px">
        <Heading size="2xl">Something went wrong!</Heading>
        <Text>{error.message || 'An unexpected error occurred.'}</Text>
        <Box display="flex" gap={4}>
          <Button onClick={reset}>Try Again</Button>
          <Button variant="outline" asChild>
            <Link href="/">Go Home</Link>
          </Button>
        </Box>
      </VStack>
    </Flex>
  );
}
